<template>
  <div class="bookmarks-container pb-3">
    <div v-if="isLoading">
      <generic-loading-skeleton />
    </div>
    <div v-else>
      <div class="pb-2"><h2>Bookmarks</h2></div>
      <div class="alert alert-error" v-if="isErrored">
        {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
      </div>
      <div v-else>
        <div v-if="bookmarksExist">
          <div
            class="bookmark-entry pb-16-px pl-1"
            v-for="bookmark in bookmarks.slice(0, 5)"
            :key="bookmark.id"
          >
            <a
              :href="bookmark.url"
              @click="handleBookmarkClick(bookmark)"
              :target="getBookmarkTarget(bookmark.url)"
            >
              <div class="d-flex">
                <span
                  ><font-awesome-icon
                    class="bookmark-icon mr-2"
                    :icon="['fas', 'bookmark']"
                /></span>
                <span class="bookmark-link-title">{{ bookmark.title }} </span>
              </div>
            </a>
          </div>

          <div
            class="text-nowrap mt-1"
            v-if="bookmarksExist"
            @click="trackViewAllClick('View all bookmarks selected')"
          >
            <router-link :to="{ name: 'bookmarks-page' }" class="view-all-link">
              <span>View all</span>
            </router-link>
          </div>
        </div>
        <div v-else class="mt-2 pb-3 no-bookmarks-block d-flex">
          <div>
            <font-awesome-icon
              class="info-circle"
              :icon="['fas', 'info-circle']"
            />
          </div>
          <div>
            <div class="my-2 no-bookmarks-title">
              Bookmark or Follow pages to get started
            </div>
            <div>
              <!--  Add back when recommendations are available 
               <router-link
                class="get-started-title"
                :to="{ name: 'bookmarks-page' }"
              >
                <span>Get started</span>
              </router-link> --> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import AutodeskOneBookmarksMixin from "@/mixins/AutodeskOneBookmarksMixin";
import GenericLoadingSkeleton from "./GenericLoadingSkeleton";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

library.add({ faBookmark, faInfoCircle });

export default {
  name: "Bookmarks",
  mixins: [AutodeskOneBookmarksMixin, HomebaseMixpanelMixin],
  components: {
    GenericLoadingSkeleton,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      bookmarks: null,
      /*Offset - number of bookmarks to show on the home page*/
      offset: 6,
    };
  },
  computed: {
    bookmarksExist() {
      return this.bookmarks && this.bookmarks.length > 0;
    },
  },
  created() {
    this.initializeBookmarks();
  },
  methods: {
    async initializeBookmarks() {
      this.isLoading = true;
      try {
        let res = await this.getAllBookmarks(this.offset);
        this.bookmarks = res;
      } catch (e) {
        // suppress error
        this.isErrored = true;
      } finally {
        this.isLoading = false;
      }
    },

    handleBookmarkClick(bookmark) {
      let title = bookmark.title;
      let url = bookmark.url;
      let subEvent = `${title} - ${url}`;
      this.trackBookmarkClick(subEvent);
    },
  },
};
</script>

<style scoped>
.panel-title-sm {
  padding-bottom: 20px;
}
.bookmarks-container {
  padding-bottom: 28px;
}
.bookmark-icon {
  font-size: 20px;
  color: var(--bookmark-color) !important;
  margin: 0px 10px;
  margin-left: auto;
}
.bookmark-link-title {
  color: rgba(102, 102, 102, 1);
  display: inline !important;
  position: relative;
}
.bookmark-entry {
  color: #000 !important;
}

.no-bookmarks-block {
  background-color: rgba(95, 96, 255, 0.1);
  padding-top: 8px;
  border-radius: 7px;
}
.no-bookmarks-title {
  font-style: italic;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 600;
}
.get-started-title {
  font-weight: 700;
  text-decoration: underline;
}
.info-circle {
  color: dimgrey;
  margin: 5px 10px 5px 13px;
  width: 22px;
  height: 23px;
}
.chevron-right-icon {
  color: #666;
  height: 15px;
}

.bookmark-link-title:after {
  width: 10px !important;
  height: 10px !important;
  position: absolute;
  color: #666;
  margin-left: 8px;
  bottom: 12px;
}
.bookmark-entry > a:hover {
  text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/Bookmarks.vue